import type { DevModeSnippetExample } from '@cli-types/next-adapter/generators.js'
import { formatJsonValue } from './format-json-value.js'
export function createExample(label: string, value: unknown): DevModeSnippetExample {
  return {
    label,
    language: 'json',
    code: formatJsonValue(value)
  }
}
